export default __webpack_public_path__ + "static/media/problema-05.5097a5f5.webp";